import type {AxiosError} from "axios";

import {getAxiosErrorMessage} from "@/src/modules/core/lib/tanstack-error";

import {isBreakBusinessError} from "./break-action-errors";

/** Expected business rejection on officer shift mutations (4xx). */
export function isShiftGateBusinessError(error: unknown): boolean {
  return isBreakBusinessError(error);
}

export function getShiftGateErrorTitle(error: unknown): string {
  if (!isShiftGateBusinessError(error)) {
    return "Shift action could not be completed.";
  }

  const [message] = getAxiosErrorMessage(error as AxiosError);
  if (message?.trim()) {
    return message.trim();
  }

  return "Shift action could not be completed.";
}
